// extracted by mini-css-extract-plugin
module.exports = {"parentContainerModal":"styles_parentContainerModal__1E-DA","textDrop":"styles_textDrop__11tmO","modalButtons":"styles_modalButtons__2WLbl"};